import apiClient, { safeJson } from '@/api/client';
import {
    CoachWorkExceptionResponse,
    GetCoachWorkExceptionParams,
    PatchCoachWorkExceptionBody,
} from './types';

/**
 * @method get
 * @brief 강사 예외근무시간 조회
 */
export const getCoachWorkExceptions = async ({ centerId, year, month }: GetCoachWorkExceptionParams) => {
    const res = await apiClient.get(`v1/coachWorkExceptions/center/${centerId}`, {
        searchParams: { year, month },
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CoachWorkExceptionResponse | null,
    };
};

/**
 * @method patch
 * @brief 강사 예외근무시간 설정 (upsert)
 */
export const patchCoachWorkExceptions = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: PatchCoachWorkExceptionBody;
}) => {
    const res = await apiClient.patch(`v1/coachWorkExceptions/center/${centerId}`, {
        json: body,
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CoachWorkExceptionResponse | null,
    };
};
